import { fetchJWVideo } from '../../../models/content'
import { uaaFetchStatus } from '../../../models/auth'
import router from '../../../router'

const getJWVideo = async (context, data) => {
  try {
    await uaaFetchStatus()
  } catch (e) {
    router.push({
      name: 'error',
      params: { status: e.error.http_code, message: 'Session has expired.' },
    })
    return
  }
  try {
    const response = await fetchJWVideo(data)
    context.commit('JW_VIDEO_UPDATED', response)
  } catch (error) {
    if (
      error ===
      'Oh Dip!  You need an active subscription to continue.  Please visit (URL HERE) to get started.'
    ) {
      context.dispatch(
        'app/setError',
        `Subscription Required. You will be redirected to our subscriptions page in a moment.`,
        { root: true }
      )
      setTimeout(() => {
        window.location.assign('https://ine.com/pages/all-access-pass')
      }, 3000)
    } else {
      context.dispatch(
        'app/setError',
        `${error} when trying to find the selected video.`,
        { root: true }
      )
    }
  }
}

const setPlayingVideoId = (context, videoId) => {
  context.commit('PLAYING_VIDEO_ID_UPDATED', videoId)
}

const setPlayingVideoTime = (context, time) => {
  context.commit('PLAYING_VIDEO_TIME_UPDATED', time)
}

const setIsWatchingFullscreen = (context, isWatchingFullscreen) => {
  context.commit('IS_WATCHING_FULLSCREEN_UPDATED', isWatchingFullscreen)
}

const setCurrentQuizId = (context, quizId) => {
  context.commit('CURRENT_QUIZ_ID_UPDATED', quizId)
}

export default {
  getJWVideo,
  setPlayingVideoId,
  setPlayingVideoTime,
  setIsWatchingFullscreen,
  setCurrentQuizId,
}
